module.exports = __webpack_public_path__ + "img/Questions-amico.aa0892b4.svg";